export const energyUnitsEnum = {
  Wh: 'Wh',
  kWh: 'kWh',
  MWh: 'MWh',
} as const

export type EnergyUnitsEnum = (typeof energyUnitsEnum)[keyof typeof energyUnitsEnum]

export type EnergyUnits = EnergyUnitsEnum